import Vue          from 'vue'
import Vuex         from 'vuex'
import Immobilier   from './immobilier.js'
import OffreEmploi  from './offreEmploi.js'
import FormulaireCandidature    from './formulaireCandidature.js'
import Organisme    from './organisme.js'
import FileData     from './filedata.js'


// VueX permet de partager facilement les données métiers entre les différents composants
// Tout modification d'une donnée présente dans le state est tracée : Cela facilite grandement la mise au point et le debuggage
// On peut suivre les modifications du state grâce à l'extension VueJS dans Chrome
// Etant donné que VueX n'alourdit pas une application Vue, il est recommandé de l'utiliser même pour des petites applications
// Il faut voir le state comme des variables de sessions globales à toute l'application

Vue.use(Vuex)

export default new Vuex.Store({
  /**
   * MODULES
   */
  modules: {
    'immobilier': Immobilier,
    'offreEmploi': OffreEmploi,
    'organisme' : Organisme,
    'formulaireCandidature' : FormulaireCandidature,
    'filedata'  : FileData
  }
})

